import { defineMessages } from 'react-intl';

export default defineMessages({
  oauth: {
    id: 'netsuite_integration_method.token_based_authentication.title',
    defaultMessage: 'Token based authentication (OAuth)',
  },
  oauth2_m2m: {
    id: 'netsuite_integration_method.oauth2_m2m.title',
    defaultMessage: 'OAuth 2.0 (Machine-to-Machine)',
  },
});
